import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import toast from "react-hot-toast";
import CustomPagination from "../../Components/Utility/CustomPagination";
import { ImageSkeleton, LineSkeleton } from "../../Components/Utility/Skeletons";
import { fetchCmsMetaData } from "../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";

function Wishlist() {
  const [wishlist, setWishlist] = useState([]);
  const [baseUrl, setBaseUrl] = useState();
  const [loading, setLoading] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [meta,setMeta] = useState();
  const limit = 6;

   // ✅ Make fetchWishlist reusable
  const fetchWishlist = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/user/getWishlist?page=${currentPage}&per_page=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (res.data.status && res.data.data) {
        setWishlist(res.data.data);
        setBaseUrl(res.data.base_url);
        setTotalPages(res?.data?.pagination?.last_page || 1);
        setCurrentPage(res?.data?.pagination?.current_page || 1);
        setTotalItems(res?.data?.pagination?.total || 0);
      }
    } catch (err) {
      console.error("Error fetching wishlist:", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Fetch wishlist when component mounts or page changes
  useEffect(() => {
    fetchWishlist();
  }, [currentPage]);
 // ✅ re-fetch on page change

 const handleRemoveWishlist = async (experienceId) => {
  const token = localStorage.getItem("authToken");
  if (!token) return;
const storedWishlist =
        JSON.parse(localStorage.getItem("userWishlist")) || [];
  try {


    const res = await axios.post(
      `${process.env.REACT_APP_API_BASE}/user/removeFromWishlist`,
      { experience_id: experienceId },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.status) {
     

     toast.success(res.data.message || "Removed from wishlist!");
     const updatedWishlist = storedWishlist.filter(
            (id) => id !== experienceId
          );
          localStorage.setItem("userWishlist", JSON.stringify(updatedWishlist));
     fetchWishlist();

    } else {
      console.error(res.data.message || "Failed to remove from wishlist.");
    }
  } catch (err) {
    console.error("Error removing from wishlist:", err);
  }
};


  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [currentPage]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

   useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("wishlist");
      setMeta(data);
    };

    loadMeta();
  }, []);

  return (
    <section className="mng_bottomss user_allls wishliststs">
        <SetMetaTags
        title= {meta?.meta_title || "Wishlist | Weyfarin"}
        description={meta?.meta_description || "Wishlist | Weyfarin"}
      
      />

      <div className="bedcramss">
        <Link to="/profile">Dashboard</Link> &gt; Wishlist
      </div>

      <div className="prfo_listst lastsst al_sec_ctxt pt-4">
        <h4>
          Wishlist{" "}
          {!loading && (
            <span>
              ({totalItems})
            </span>
          )}
        </h4>

        <div className="row">
          {loading ? (
            Array.from({ length: 6 }).map((_, index) => (
              <div key={index} className="col-lg-4 col-sm-4">
                <ImageSkeleton height="200px" />
                <LineSkeleton width="60%" />
                <LineSkeleton width="40%" />
              </div>
            ))
          ) : wishlist.length > 0 ? (
            wishlist.map((item, index) => {
              const slug = item.experience_title
                ? item.experience_title.replace(/[\s,]+/g, "-").toLowerCase()
                : "unknown";

              return (
                <div key={index} className="col-lg-4 col-sm-4">
                  <Link
                    to={`/experience/${item.url_slug}`}
                    className="bike_ara_all"
                  >
                    <div className="bike_mg_ar">
                      <span class="reatingsg ones"  onClick={(e) => {
    e.preventDefault(); // stop link navigation
    e.stopPropagation(); // prevent bubbling
    handleRemoveWishlist(item.experience_id);
  }}><i class="fa fa-trash"></i></span>
                      <div className="mdll">
                        <img
                          src={
                            item.image
                              ? `${baseUrl}${item.image}`
                              : "images/choose_experiences_sm1.jpg"
                          }
                          className="mg_sm_araea"
                          alt={item.experience_title || "wishlist"}
                        />
                      </div>
                    </div>
                    <div className="tx_box">
                      <h4>{item.experience_title || "Untitled"}</h4>
                      <p>{item.saved_count ? `${item.saved_count} saved` : ""}</p>
                    </div>
                  </Link>
                </div>
              );
            })
          ) : (
		  <div className="col-lg-12 mb-3">
            <p className="text-center">No wishlist items found.</p>
		  </div>
          )}
        </div>

        {/* ✅ Pagination placed below all cards */}
        {!loading && totalPages > 1 && (
          <div className="pagination-container text-center mt-4">
            <CustomPagination
              currentPage={currentPage}
              lastPage={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </section>
  );
}

export default Wishlist;
